import { metaAdapter } from '@/adapters/wiki/meta';

const pageAdapter = (data) => {
  const { reference_image } = data;

  return {
    id: data.id,
    slug: data.slug,
    title: data.title,
    href: data.href,
    referenceImage: reference_image
      ? {
          id: reference_image.id,
          original: reference_image.original,
        }
      : null,
  };
};

export const pagesAdapter = ({ data, meta }) => {
  return {
    data: data.map((item) => pageAdapter(item)),
    meta: metaAdapter(meta),
  };
};
